//====================================================
//UHS we use this file
//====================================================
$(document).ready(function() {

  // Toggle L1 dropdown on click
  $(document).on('click', '.nav-l1-btn[data-nav-l1]', function(event) {
    event.preventDefault();
    var $item = $(this).closest('.nav-l1-item');
    var isOpen = $item.hasClass('nav-open');

    // Close all open dropdowns first
    $('.nav-l1-item.nav-open').removeClass('nav-open');
    $('.nav-l2-item.nav-open').removeClass('nav-open');
    $('.nav-l3-panel').empty().removeClass('nav-l3-panel--active');
    $(document).find('.nav-l1-btn[data-nav-l1]').attr('aria-expanded', 'false');

    if (!isOpen) {
      $item.addClass('nav-open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  // Show L3 panel on L2 button click (right-column approach)
  $(document).on('click', '.nav-l2-btn[data-nav-l2]', function(event) {
    event.preventDefault();
    event.stopPropagation();
    var $item    = $(this).closest('.nav-l2-item');
    var $panel   = $(this).closest('.nav-dropdown-panel');
    var $l3Panel = $panel.find('.nav-l3-panel');
    var isOpen   = $item.hasClass('nav-open');

    // Close siblings
    $item.siblings('.nav-l2-item.nav-open').removeClass('nav-open');
    $l3Panel.empty().removeClass('nav-l3-panel--active');

    if (!isOpen) {
      $item.addClass('nav-open');
      var goToUrl   = $item.data('l3-go-to-url');
      var goToTitle = $item.data('l3-go-to-title');
      var html = '<a href="' + goToUrl + '" class="nav-l3-go-to">View All ' + goToTitle + '</a>';
      $item.find('.nav-l3-list li').each(function() {
        html += '<a href="' + $(this).data('url') + '">' + $(this).text() + '</a>';
      });
      $l3Panel.html(html).addClass('nav-l3-panel--active');
    }
  });

  // Close all dropdowns when clicking outside the nav
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.nav-l1-item').length) {
      $('.nav-l1-item.nav-open').removeClass('nav-open');
      $('.nav-l2-item.nav-open').removeClass('nav-open');
      $('.nav-l3-panel').empty().removeClass('nav-l3-panel--active');
      $(document).find('.nav-l1-btn[data-nav-l1]').attr('aria-expanded', 'false');
    }
  });

});
